import React from 'react';
import ExperienceForm from '../../../../components/Experiences/Form/ExperienceForm';

const ExperienceFormPage = () => {
    return (
        <>
            <ExperienceForm />
        </>
    );
};

export default ExperienceFormPage;
